(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // ランキングバッジを自動追加(特定のセクションのみ)
  document.addEventListener('DOMContentLoaded', function() {
    // ランキングセクションのみを対象にする
    const rankingSection = document.querySelector('#shopify-section-template--18942181933231__product_list_BRpmxa');
    
    if (rankingSection) {
      // 最も外側のproduct-cardのみを取得(入れ子を除外)
      const allCards = rankingSection.querySelectorAll('product-card[data-product-id]');
      const productCards = Array.from(allCards).filter(card => {
        // 親要素にproduct-cardがないものだけを取得
        return !card.parentElement.closest('product-card[data-product-id]');
      });
      
      productCards.forEach((card, index) => {
        const position = index + 1;
        
        // 10位まで表示
        if (position <= 10) {
          // 既存のバッジがあれば削除
          const existingBadge = card.querySelector('.product-card__ranking-badge');
          if (existingBadge) existingBadge.remove();
          
          // バッジを作成
          const badge = document.createElement('div');
          badge.className = `product-card__ranking-badge ranking-${position}`;
          
          let badgeHTML = '';
          if (position === 1) {
            badgeHTML = '<span class="ranking-badge ranking-gold">🥇 1位</span>';
          } else if (position === 2) {
            badgeHTML = '<span class="ranking-badge ranking-silver">🥈 2位</span>';
          } else if (position === 3) {
            badgeHTML = '<span class="ranking-badge ranking-bronze">🥉 3位</span>';
          } else {
            badgeHTML = `<span class="ranking-badge">${position}位</span>`;
          }
          
          badge.innerHTML = badgeHTML;
          card.insertBefore(badge, card.firstChild);
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
